import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  BRANDS_LISTING_ADD_PATH,
  BRANDS_LISTING_PATH,
  BRANDS_LISTING_UPDATE_PATH,
} from "utils/constants/paths";

const BrandsDetailsPage = Loadable(React.lazy(() => import("./View")));
const BrandsDetailsPageAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate")),
);

export const BrandsRoute: IRouteItem = {
  path: BRANDS_LISTING_PATH,
  element: React.createElement(BrandsDetailsPage),
  name: "Brands Listing",
  children: [
    {
      name: "Add / Update",
      path: BRANDS_LISTING_ADD_PATH,
      element: React.createElement(BrandsDetailsPageAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: BRANDS_LISTING_UPDATE_PATH,
      element: React.createElement(BrandsDetailsPageAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
